export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/abstract.d61a4d6.svg";